import React from 'react';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip'
import MultiSelectInput from '../../inputs/MultiSelectInput';


class Process extends React.Component {

    state = {
        local: undefined,
        week: [],
        hour: ''
    }

    handleClickWeek = (day) => (event) => {
        const { week } = this.state;
        var index = week.indexOf(day);

        if (index < 0) {
            week.push(day);
        } else {
            week.splice(index, 1);
        }

        this.setState({
            week: [...week],
        });
    }

    handleLocalesChange = input => {
        this.setState({ local: input.value })
    }

    handleChangeMain = event => {
        this.props.onChange(this.props.id, event.target.name, event.target.checked)
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    render() {
        const { intl, info, id, locales, programacion, quota, list } = this.props;
        const { local, week, hour } = this.state;

        const localeslist = locales.map((t) => { return { label: t.nombre, value: t.id } });
        const ds = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
        const days = [
            'form_week_day_monday',
            'form_week_day_tuesday',
            'form_week_day_wednesday',
            'form_week_day_thursday',
            'form_week_day_friday',
            'form_week_day_saturday',
            'form_week_day_sunday',
        ];
        console.log(list, quota);
        if (!this.props.programacion) {
            return (
                <div className="flex_full_column ob_permission align_center ob_permission_column margin_bottom_12 ">
                    <div className="flex_auto_row width100 align_center">
                        <span className="flex_full_row ob_permission_title">{info.nombre}</span>
                        <Switch
                            name={"seleccionable"}
                            checked={!!this.props.programacion}
                            disabled={!this.props.programacion && ( !info.seleccionable || list.length >= quota ) }
                            onChange={this.props.onProcess(id)}
                            value="seleccionable"
                            color="primary"
                        />
                    </div>
                    <div className="flex_auto_row width100 align_center hand">
                        <span className="flex_full_row ob_permission_descripcion c_bluish">{info.descripcion}</span>
                    </div>
                    {!info.seleccionable &&
                        <div className="flex_auto_row width100 align_center hand">
                            <span className="flex_full_row ob_only_in_other_license c_lipstick">
                                {intl.formatMessage({ id: 'ob_only_in_other_license' })}
                            </span>
                        </div>
                    }
                    {(info.seleccionable && list.length >= quota ) &&
                        <div className="flex_auto_row width100 align_center hand">
                            <span className="flex_full_row ob_only_in_other_license c_lipstick">
                                {intl.formatMessage({ id: 'ob_only_in_limit_license' })}
                            </span>
                        </div>
                    }
                </div>

            );
        } else {
            return (
                <div className="flex_full_column ob_permission align_center ob_permission_column margin_bottom_12 ">
                    <div className="flex_auto_row width100 align_center">
                        <span className="flex_full_row ob_permission_title">{info.nombre}</span>
                        <Switch
                            name={"seleccionable"}
                            checked={!!this.props.programacion}
                            onChange={this.props.onProcess(id)}
                            value="seleccionable"
                            color="primary"
                        />
                    </div>
                    <div className="flex_auto_row width100 align_center hand">
                        <span className="flex_full_row ob_permission_descripcion c_bluish">{info.descripcion}</span>
                    </div>
                    <div className="flex_auto_row align_center margin_top_24 width100">
                        <Switch
                            name={'sts'}
                            checked={programacion && programacion.sts ? programacion.sts : false}
                            onChange={this.handleChangeMain}
                            value="sts"
                            color="primary"
                        />
                        <div className="flex_auto_row select-input-label width100">
                            {intl.formatMessage({ id: 'ob_sts' })}
                        </div>
                    </div>
                    {info.programable &&
                        <React.Fragment>
                            <div className="flex_auto_row width100 align_center margin_top_24 ">
                                <MultiSelectInput
                                    defaultValue={localeslist.filter((f) => f.value === local)}
                                    placeHolder={intl.formatMessage({ id: 'local' })}
                                    options={localeslist}
                                    onChange={this.handleLocalesChange}
                                    isSimple
                                />
                            </div>
                            <div className="flex_auto_column width100 align_center margin_top_24 text_align_left_important ">
                                <span className="MuiFormLabel-root margin_right_12 margin_bottom_12">{intl.formatMessage({ id: 'ob_day' })} </span>
                                <div className="flex_auto_row width100 align_center">
                                    {days.map((d, i) => {
                                        const value = week.indexOf(ds[i]) >= 0;
                                        return (
                                            <div key={`day-${d}`} className="rowwrap">
                                                <div
                                                    onClick={this.handleClickWeek(ds[i])}
                                                    className={
                                                        'cell text_align_center hand c_white' +
                                                        (value ? ' bg_bluish ' : ' bg_cool_grey')
                                                    }
                                                >
                                                    {intl.formatMessage({ id: d })}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="flex_auto_row width100 align_center margin_top_24 ">
                                <TextField
                                    name="hour"
                                    label={intl.formatMessage({ id: 'time_field_label' })}
                                    type="time"
                                    fullWidth
                                    className="margin_bottom_12"
                                    value={hour}
                                    onChange={this.handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 1800, //5 min
                                    }}
                                />
                            </div>
                            <div className="flex_auto_row width100 align_center margin_top_12 elements_from_right">
                                <span onClick={this.props.onAdd(id, local, week, hour)}
                                    className={"ob_process_add " + (!!local && !!hour && week.length > 0 ? "c_bluish hand" : "c_disabled")}>
                                    {intl.formatMessage({ id: 'ob_process_add' })}
                                </span>
                            </div>
                            <div className="flex_auto_row width100 align_center margin_top_24 ob_process_subtitle_row">
                                <span className="ob_process_subtitle">{intl.formatMessage({ id: 'ob_process_subtitle' })} </span>
                            </div>
                            <div className="flex_auto_column width100 align_center margin_top_24 text_align_left_important ">
                                {/* ${localeslist.find((l) => l.value === i.local).label}  */}
                                {programacion &&
                                    programacion.programaciones &&
                                    programacion.programaciones.map((i, index) =>
                                        <Chip
                                            key={`prog-${id}-${index}`}
                                            color="primary"
                                            label={`${localeslist.find((l) => l.value === i.local) ? localeslist.find((l) => l.value === i.local).label : ''} | ${i.dow} ${i.hora} `}
                                            className="margin_bottom_12 margin_right_12" 
                                            onDelete={this.props.onDelete(id, index)}
                                        />
                                    )
                                }
                            </div>
                        </React.Fragment>
                    }
                </div>
            );
        }
    }
}

export default Process;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/process.js